// import MyOrders from "../orders";
// import Checkout from "../orders/Checkout";

export enum RouteKeys {
  Home = "/",
  CouponDetails = '/coupons-details',
  CouponDetailsGreen = '/coupons-green-view',
}
